import { render, staticRenderFns } from "./HiddenPostsAlert.vue?vue&type=template&id=472f9200"
import script from "./HiddenPostsAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./HiddenPostsAlert.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports